export default __webpack_public_path__ + "ui/assets/img/checked-black-16.svg";